var DestinationDetails = /** @class */ (function () {
    function DestinationDetails(_a) {
        var id = _a.id, destination = _a.destination, etls = _a.etls, data = _a.data, charts = _a.charts;
        this.id = id;
        this.destination = destination;
        this.etls = etls;
        this.data = data;
        this.charts = charts;
    }
    DestinationDetails.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, destination = _a.destination, etls = _a.etls, data = _a.data, charts = _a.charts;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (!Array.isArray(etls))
            throw new Error('etls must be an array');
        if (typeof charts !== undefined && !Array.isArray(charts))
            throw new Error('charts must be an array');
        return new DestinationDetails({
            id: id,
            destination: destination,
            etls: etls,
            data: data,
            charts: charts,
        });
    };
    return DestinationDetails;
}());
export default DestinationDetails;
